import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { Link } from "react-router-dom";

const values = [
  { icon: "ri-flashlight-fill", title: "新作首发", desc: "坚持第一时间上架新作与独家内容，让读者永远快人一步看到最新作品。" },
  { icon: "ri-vip-crown-2-fill", title: "独家抢先看", desc: "与作者和版权方深度合作，争取全网领先的独家抢先看权益与更新进度。" },
  { icon: "ri-chat-3-fill", title: "内容品质", desc: "严格甄选作品与画风，为不同喜好的读者提供真正值得追的高品质漫画。" },
  { icon: "ri-heart-3-fill", title: "读者为本", desc: "倾听读者反馈，持续打磨分类、榜单与追更体验，让追番更轻松更快乐。" },
];

const steps = [
  { num: "01", title: "甄选新作", desc: "从众多投稿与授权中甄选有潜力、有品质的新作，第一时间纳入上架计划。" },
  { num: "02", title: "抢先更新", desc: "与作者协同排期，确保新番首发与独家内容领先全网稳定更新速递。" },
  { num: "03", title: "运营与推荐", desc: "通过分类、榜单与编辑推荐，把好作品精准推送给对味的读者。" },
  { num: "04", title: "持续陪伴", desc: "长期运营与陪伴，让每一位读者都能在这里找到追更的归属感。" },
];

export default function About() {
  return (
    <>
      <Navbar />
      <PageHeader
        crumbs={[
          { label: "首页", to: "/" },
          { label: "关于我们" },
        ]}
        title="关于叮咚漫画网"
        desc="叮咚漫画网是专注新作首发与独家抢先看的内容型漫画平台，新番上架速递，让每一位读者永远快人一步。"
      />
      <main className="bg-background-50">
        <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid items-center gap-10 md:grid-cols-2 md:gap-14">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                <i className="ri-flag-2-line" /> 品牌介绍
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                为爱追更的人，提供快人一步的阅读体验
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                叮咚漫画网成立的初衷很简单：让热爱漫画的人，不再错过任何一部好作品。我们围绕「新作首发 / 独家抢先看 / 新番上架速递」三大核心，第一时间上架新作与独家内容，每日更新新作列表，把热门新漫第一时间送到读者眼前。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                从热血冒险到恋爱治愈，从玄幻仙侠到悬疑烧脑，我们不断扩充内容版图，用清晰的分类、实时的榜单和贴心的追更体验，陪伴每一位读者的追番之路。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20cozy%20reading%20room%20filled%20with%20colorful%20manga%20volumes%20and%20warm%20lamplight%2C%20comfortable%20armchair%2C%20warm%20coral%20and%20amber%20palette%20with%20cream%20walls%2C%20relaxing%20welcoming%20mood%2C%20clean%20detailed%20illustration%20style&width=800&height=900&seq=about-01&orientation=portrait"
                alt="叮咚漫画网 舒适的追更阅读氛围"
                title="叮咚漫画网阅读氛围"
                className="h-48 w-full rounded-xl border border-background-200 object-cover md:h-56"
              />
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20group%20of%20young%20friends%20reading%20and%20discussing%20manga%20together%20at%20a%20sunny%20table%2C%20joyful%20youthful%20energy%2C%20warm%20coral%20and%20teal%20accents%20on%20cream%20background%2C%20friendly%20community%20mood%2C%20clean%20vibrant%20illustration%20style&width=800&height=900&seq=about-02&orientation=portrait"
                alt="叮咚漫画网 读者共同追更交流"
                title="叮咚漫画网追更社区"
                className="mt-6 h-48 w-full rounded-xl border border-background-200 object-cover md:h-56"
              />
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16" aria-label="核心价值">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="mx-auto mb-8 max-w-xl text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                <i className="ri-award-line" /> 核心价值
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们坚持的四件事</h2>
            </div>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
              {values.map((v) => (
                <div key={v.title} className="rounded-xl bg-background-50 border border-background-200 p-5">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-2xl text-background-50">
                    <i className={v.icon} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{v.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-label="发展理念">
          <div className="mx-auto mb-8 max-w-xl text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-road-map-line" /> 发展理念
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">每一步，都围绕读者成长</h2>
          </div>
          <div className="grid gap-6 md:grid-cols-4">
            {steps.map((s) => (
              <div key={s.num} className="relative rounded-xl bg-background-100 border border-background-200 p-5 md:p-6">
                <span className="font-heading text-3xl font-bold text-primary-300">{s.num}</span>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                <span className="absolute -right-1 top-1/2 hidden -translate-y-1/2 text-2xl text-foreground-200 md:block">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16" aria-label="联系引导">
          <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 rounded-2xl border border-background-200 bg-background-50 px-6 py-10 text-center md:flex-row md:justify-between md:px-10 md:text-left">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">想和我们聊聊？</h2>
              <p className="mt-2 text-sm text-foreground-600">无论是作品合作、版权洽谈还是读者反馈，欢迎随时联系我们。</p>
            </div>
            <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600">
              <i className="ri-mail-send-line" /> 联系我们
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于叮咚漫画网",
            description: "叮咚漫画网是专注新作首发与独家抢先看的内容型漫画平台，新番上架速递，让读者永远快人一步。",
            url: "https://fangupdate.github.io/about",
            inLanguage: "zh-CN",
            isPartOf: { "@type": "WebSite", name: "叮咚漫画网", url: "https://fangupdate.github.io/" },
          }),
        }}
      />
    </>
  );
}